"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
var _Buttons = _interopRequireDefault(require("../../components/Cart/Buttons"));
var _CartItem = _interopRequireDefault(require("../../components/Cart/CartItem"));
var _Error = _interopRequireDefault(require("../../components/Cart/Error"));
var _Header = _interopRequireDefault(require("../../components/Cart/Header"));
var _Price = _interopRequireDefault(require("../../components/Cart/Price"));
var _RewardPoints = _interopRequireDefault(require("../../components/Cart/RewardPoints"));
var _TotalPrice = _interopRequireDefault(require("../../components/Cart/TotalPrice"));
var _CartOverlay = _interopRequireDefault(require("./CartOverlay.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CartOverlay = _ref => {
  let {
    lang = "de",
    position = "right"
  } = _ref;
  const {
    REACT_APP_SPA
  } = process.env;
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    cart,
    openCart,
    setOpenCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    rewardPoints
  } = shopData || {};
  const {
    address,
    isGuest = false,
    items = [],
    prices,
    _loading = false
  } = cart || {};
  const navigate = (0, _useLink.default)();
  const css = (0, _CartOverlay.default)();
  const entries = (0, _react.useMemo)(() => {
    var _items$length;
    return (_items$length = items.length) !== null && _items$length !== void 0 ? _items$length : 0;
  }, [items]);
  const handleCheckoutClick = () => {
    setOpenCart(false);
    if (isGuest && (0, _isEmpty.default)(address)) {
      if (REACT_APP_SPA === "true") {
        navigate("/".concat(lang, "/shop/checkout"));
      } else {
        window.location.href = "/".concat(lang, "/shop/checkout");
      }
      return;
    }
    if (REACT_APP_SPA === "true") {
      navigate("/".concat(lang, "/shop/checkout"));
    } else {
      window.location.href = "/".concat(lang, "/shop/checkout");
    }
  };
  const handleShopClick = () => {
    setOpenCart(false);
  };
  return /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    anchor: position,
    classes: {
      root: (0, _clsx.default)(css.cartOverlay, "mco-shop-cart-overlay"),
      paper: (0, _clsx.default)(css.paper, "mco-shop-cart-overlay__paper")
    },
    disableScrollLock: true,
    open: openCart,
    onClose: () => setOpenCart(false)
  }, /*#__PURE__*/_react.default.createElement(_Header.default, {
    lang: lang
  }), entries > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-cart-content")
  }, items === null || items === void 0 ? void 0 : items.map(item => {
    const {
      guid
    } = item;
    return /*#__PURE__*/_react.default.createElement(_CartItem.default, _extends({
      key: guid,
      lang: lang
    }, item));
  }), !(0, _isEmpty.default)(rewardPoints) && /*#__PURE__*/_react.default.createElement(_RewardPoints.default, {
    lang: lang
  })), /*#__PURE__*/_react.default.createElement(_Price.default, {
    lang: lang,
    prices: prices
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.sticky, "mco-shop-cart-sticky")
  }, /*#__PURE__*/_react.default.createElement(_TotalPrice.default, {
    lang: lang,
    prices: prices
  }), /*#__PURE__*/_react.default.createElement(_Buttons.default, {
    lang: lang,
    onCheckoutClick: handleCheckoutClick,
    onShopClick: handleShopClick
  }))), entries === 0 && !_loading && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-cart-content")
  }, /*#__PURE__*/_react.default.createElement(_Error.default, {
    lang: lang,
    onClick: () => setOpenCart(false)
  })));
};
var _default = exports.default = CartOverlay;